<div class="clarity-insight" *ngIf="entry">
  <div class="clarity-title"><img src="assets/clarity.png" height="20" width="20"> Community insights - provided by Clarity</div>
  <div class="lines" *ngIf="entry.descriptions.en">
    <div class="line" *ngFor="let lines of entry.descriptions.en" [classList]="lines.classNames || []">
      <span [classList]="line.classNames || []" *ngFor="let line of lines.linesContent">{{line.text}}</span>
    </div>
  </div>
</div>
